import SidebarComponent from './sidebar.component'

const SidebarModule = angular.module('cdbl.layout.sidebar', [

])
  .component('cdblSidebar', SidebarComponent)
  .name

export default SidebarModule
